<div *ngIf="recentJobs.length > 0" class="mt-8 bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
  <div class="bg-gradient-to-r from-emerald-50 to-teal-50 border-b border-gray-100 p-6">
    <h2 class="text-xl font-semibold text-gray-800 flex items-center">
      <svg class="w-5 h-5 mr-2 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
        </path>
      </svg>
      Mis Reportes Recientes
    </h2>
    <p class="text-gray-600 text-sm mt-1">Reportes generados en las últimas 24 horas</p>
  </div>
  <div class="p-6">
    <div class="overflow-x-auto">
      <table class="w-full text-sm text-left">
        <thead class="text-xs text-gray-700 uppercase bg-gray-50 rounded-lg">
          <tr>
            <th class="px-4 py-3">Estado</th>
            <th class="px-4 py-3">Tipo</th>
            <th class="px-4 py-3">Archivo</th>
            <th class="px-4 py-3">Fecha</th>
            <th class="px-4 py-3">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let job of recentJobs" class="border-b border-gray-100 hover:bg-gray-50">
            <td class="px-4 py-3">
              <span *ngIf="job.status === 'Completed'"
                class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                </svg>
                Completado
              </span>
              <span *ngIf="job.status === 'Processing' || job.status === 'Queued'"
                class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                <div class="animate-spin rounded-full h-3 w-3 border-b-2 border-blue-600 mr-1"></div>
                {{ job.status === 'Processing' ? 'Procesando' : 'En cola' }}
              </span>
              <span *ngIf="job.status === 'Failed'"
                class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                </svg>
                Error
              </span>
            </td>
            <td class="px-4 py-3 text-gray-700">{{ getReportTypeName(job.reportType) }}</td>
            <td class="px-4 py-3 text-gray-700">{{ job.fileName || '-' }}</td>
            <td class="px-4 py-3 text-gray-500">{{ job.createdAt | date:'dd/MM/yy HH:mm' }}</td>
            <td class="px-4 py-3">
              <button *ngIf="job.status === 'Completed'" (click)="download(job.id, job.fileName)"
                class="inline-flex items-center px-3 py-1.5 bg-emerald-600 text-white text-xs font-medium rounded-lg hover:bg-emerald-700 transition-colors">
                <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
                </svg>
                Descargar
              </button>
              <span *ngIf="job.status === 'Failed'" class="text-xs text-red-500" [title]="job.errorMessage || ''">
                {{ job.errorMessage | slice:0:50 }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
